import React from "react";

type GearButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost" | "white";
  size?: "small" | "medium" | "large";
  children: React.ReactNode;
  onClick?: () => void;
};

const GearButton: React.FC<GearButtonProps> = ({
  variant = "primary",
  size = "medium",
  children,
  className = "",
  type = "button",
  disabled,
  ...rest
}) => {
  const baseStyles = "px-4 py-2 font-medium";

  const variantStyles = {
    primary:
      "bg-[#5A18C4] text-white hover:bg-[#5A18C4]/80  flex items-center justify-center gap-2 border border-[#8200DB] ",
    secondary: "bg-secondary text-white hover:bg-secondary-600",
    ghost: "bg-transparent text-gray-800 hover:opacity-80",
    white: "bg-white text-[#364153] hover:bg-gray-100",
  };

  const sizeStyles = {
    small: "text-sm",
    medium: "text-[14px]",
    large: "text-lg",
  };

  const disabledStyles = disabled ? "opacity-60 cursor-not-allowed" : "";
  const classes = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${disabledStyles} ${className}`;

  return (
    <button className={classes} type={type} disabled={disabled} {...rest}>
      {children}
    </button>
  );
};

export default GearButton;
